var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticStyle: { height: "100vh" }, attrs: { direction: "vertical" } },
    [
      _c("el-main", [
        _c("div", { staticClass: "registration" }, [
          _c("div", { staticClass: "logo" }, [
            _c("img", { attrs: { src: _vm.images.logo } }),
          ]),
          _c("h1", [_vm._v(_vm._s(_vm.$t("registration.title03")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("registration.description02")))]),
          _c(
            "div",
            { staticClass: "send" },
            [
              _c("el-button", [
                _c("a", { attrs: { href: "/sign_in" } }, [
                  _vm._v(_vm._s(_vm.$t("registration.go_login"))),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("publicFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }